var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumPlanLrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1358",
    "data-name": "Group 1358",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 3,
    fill: "#197ff5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.362.515,6.47,4.353,2.236,4.97a.928.928,0,0,0-.513,1.582L4.786,9.538l-.725,4.217a.927.927,0,0,0,1.345.977L9.194,12.74l3.788,1.991a.928.928,0,0,0,1.345-.977L13.6,9.538l3.063-2.985a.928.928,0,0,0-.513-1.582l-4.234-.617L10.026.515a.928.928,0,0,0-1.664,0Z",
    transform: "translate(6.305 8.08)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlanLrg);
export default __webpack_public_path__ + "static/media/premium_plan_lrg.8c954a417447b26150e7a1eb07518d99.svg";
export { ForwardRef as ReactComponent };